// extracted by mini-css-extract-plugin
module.exports = {"list":"_13568"};